import { styled } from '@linaria/react'

export const Wrapper = styled.div``

export const InnerWrapp = styled.div`
  padding-top: 60px;
  padding-bottom: 60px;

  @media screen and (max-width: 768px) {
    padding-top: 30px;
    padding-bottom: 30px;
  }
`

export const Teaser = styled.div`
  position: relative;
  z-index: 1;
  align-items: center;
  justify-content: center;
  height: ${props => (props.isSlider ? '100%' : 'auto')};
  width: ${props =>
    !props.isSlider &&
    (props.grid
      ? 'calc(100% / ' + props.grid + ' - 17px)'
      : 'calc(100% / 4 - 15px)')};
  margin-bottom: 15px;
  display: ${props => (props.hidden ? 'none' : 'flex')};
  padding: 0 30px;

  @media (max-width: 1024px) {
    width: ${props => !props.isSlider && 'calc(100% / 2 - 10px)'};
  }

  img {
    max-width: 100%;
    height: auto;
  }
`

export const Index = styled.div`
  color: var(--primary);
  font-size: var(--font-size-index);
  font-weight: var(--font-weight-bold);
`

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;

  button {
    color: var(--black);
    display: inline-block;
    cursor: pointer;

    img {
      vertical-align: middle;
      margin-left: 10px;
    }
  }
`
